/* House of Mina — Touch-friendly header menu
 * Atelier's mega-menu opens on :hover, which fights touch-only devices (iPad/iPhone):
 * the first tap fires hover then immediately closes on tap-end.
 * This script makes top-level menu items with a submenu act as a tap-to-open toggle
 * on the first tap, and navigates on the second tap (standard touch-pattern).
 */
(function () {
  'use strict';

  // Only run on devices that have NO real hover (iPads, phones).
  // Desktops with mouse keep the original Atelier hover behavior.
  if (!window.matchMedia || !window.matchMedia('(hover: none)').matches) return;

  var lastOpenedTrigger = null;

  function findSubmenu(trigger) {
    if (!trigger) return null;
    // Atelier patterns: trigger sits adjacent to a list / pop / disclosure
    var li = trigger.closest('li, [role="none"], details, .header-menu, [data-disclosure]');
    if (li) {
      var sub = li.querySelector('.mega-menu__list, .menu-list__sublist, [data-submenu], ul ul, .header-menu__list');
      if (sub && sub !== trigger && !trigger.contains(sub)) return sub;
    }
    return null;
  }

  function findTrigger(target) {
    return target.closest(
      '.header-menu > a, ' +
      '.header-menu > button, ' +
      '.menu-list > li > a, ' +
      '.menu-list > li > button, ' +
      'nav[header-menu] a, ' +
      '[data-disclosure] > summary, ' +
      '[aria-haspopup="menu"], ' +
      '[aria-haspopup="true"]'
    );
  }

  function closeAllMenus() {
    document.querySelectorAll('[aria-expanded="true"]').forEach(function (el) {
      // Only touch ones inside the header
      if (el.closest('header, #header-component, .header-section, [class*="header"]')) {
        el.setAttribute('aria-expanded', 'false');
      }
    });
    lastOpenedTrigger = null;
  }

  // First-tap intercept (capture phase so we beat Atelier's own click handlers)
  document.addEventListener('click', function (e) {
    var trigger = findTrigger(e.target);
    if (!trigger) return;

    // Only intercept if the trigger has a submenu
    var submenu = findSubmenu(trigger);
    if (!submenu) return;

    // If this trigger is already the one we opened, allow navigation (second tap)
    if (lastOpenedTrigger === trigger) {
      lastOpenedTrigger = null;
      return;
    }

    // Otherwise: open this menu, prevent navigation
    e.preventDefault();
    e.stopPropagation();
    closeAllMenus();
    trigger.setAttribute('aria-expanded', 'true');
    lastOpenedTrigger = trigger;
  }, true);

  // Tap outside the header closes any open menu
  document.addEventListener('click', function (e) {
    if (!e.target.closest('header, #header-component, .header-section, [class*="header"]')) {
      closeAllMenus();
    }
  });

  // Esc closes
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllMenus();
  });
})();
